/********************************************************************
 * Copyright (c) Certus Software, 2022.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, HostListener, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {environment} from 'src/environments/environment';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'guide-aside',
  templateUrl: './guide-aside.component.html',
  styleUrls: ['./guide-aside.component.scss']
})
export class GuideAsideComponent implements OnInit {

  @Input() asideData: any;
  @ViewChild('guideBottomSheet') guideBottomSheet: TemplateRef<any>;
  env = environment;
  currentRoute: string;
  routePath: string;

  constructor(
    private bottomSheet: MatBottomSheet,
    private translate: TranslateService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.setRoutePath();
  }

  openGuideSheetMenu() {
    this.translate.get('guide.choiceAll.guideToc').subscribe( (text: string) => {
      this.bottomSheet.open(this.guideBottomSheet, { ariaLabel: text });
    });
  }

  closeGuideSheetMenu() {
    this.bottomSheet.dismiss();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.bottomSheet._openedBottomSheetRef) {
      this.bottomSheet.dismiss();
    }
  }

  setRoutePath () {
    if (this.currentRoute.includes('/windows/')) {
      this.routePath = 'pc/windows';
    }
    if (this.currentRoute.includes('/macos/')) {
      this.routePath = 'pc/macos';
    }
    if (this.currentRoute.includes('/linux/')) {
      this.routePath = 'pc/linux';
    }
    if (this.currentRoute.includes('/mobile/ios/')) {
      this.routePath = 'mobile/ios';
    }
    if (this.currentRoute.includes('/mobile/android/')) {
      this.routePath = 'mobile/android';
    }
  }
}
